class ScheduleViewSaverSingleton {
  public mode;
  public dateParams = {};

  public saveView = (modeToSave, year, month, day) => {
    this.mode = modeToSave;
    this.dateParams = {
      ...this.dateParams,
      year,
      month,
      day,
    };
  };

  public getSavedView = () => ({
    mode: this.mode,
    dateParams: this.dateParams,
  });
}

const ScheduleViewSaver = new ScheduleViewSaverSingleton();

export default ScheduleViewSaver;
